import { useEffect } from 'react';
import { isNavigationGuardActive, registerNavigationGuard } from './navigationGuard';

/** 비모달 편집에서 메뉴 이동·뒤로가기·탭 종료로 초안이 사라지는 것을 방지합니다. */
export function useUnsavedChangesGuard({ dirty, busy = false }: { dirty: boolean; busy?: boolean }) {
  useEffect(() => {
    if (!dirty && !busy) return;
    const guard = () => !busy && (!dirty || window.confirm('저장하지 않은 변경 사항을 버리고 이동할까요?'));
    const unregister = registerNavigationGuard(guard);
    const preventUnload = (event: BeforeUnloadEvent) => {
      if (!isNavigationGuardActive(guard)) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', preventUnload);
    return () => {
      unregister();
      window.removeEventListener('beforeunload', preventUnload);
    };
  }, [dirty, busy]);
}
